
export const aboutUs = {
  title: "Танилцуулга",
  description: `MBG ХХК-ийн дэргэдэх MBG Боловсролын төв нь  Монголдоо  Хятад, Англи хэлний урт болон богино хугацааны тэнхимийн сургалт,  HSK+ HSKK+CSCA-ын Тэтгэлгийн бэлтгэл анги, БНХАУ-ын их дээд сургуулиудад өвөл зуны "Хэл, Соёлын Практик сургалт АЯЛАЛ", БНХАУ-ын их дээд сургуулиудад Хятад хэл, Бакалавр, Мастер, Доктор, ОУ-ын Хятад хэлний мэргэжлийн тэтгэлэгт хөтөлбөрүүдэд оюутан залуусыг элсүүлэн суралцуулж 2016 оноос эхлэн өдгөө 10 дахь жилдээ тасралтгүй, тогтвортой, амжилттайгаар үйл ажиллагаагаа явуулж байна.` 
,
  video: "https://www.youtube.com/watch?v=FPvcVoWqLFw",
  facebook: [
  {
      name: "Learning China",
      url: "https://www.facebook.com/learningchina"
    },
  ]
}

export const aboutDetails = {
  intro: "MBG ХХК-ийн дэргэдэх MBG Боловсролын төв нь 2016 онд үүсгэн байгуулагдсан бөгөөд \"Тэг-ээс ТЭТГЭЛЭГТ ТЭНЦЭХ хүртэл нь...\" гэсэн уриатайгаар өдгөө 10 дахь жилдээ тогтмол, тасралтгүй үйл ажиллагаа явуулж байна.",
  programs: [
    "Монгол дахь Хятад, Англи хэлний гадаад багштай тэнхимийн богино, хагас жил, бүтэн жилийн сургалт",
    "Хятад дахь Хятад хэл соёлын өвөл зуны богино хугацааны практик сургалт",
    "БНХАУ-ын их дээд сургуулиудад Хэлний бэлтгэл, Базалавр, Мастер, Докторын зэргийн тэтгэлэгт хөтөлбөр",
    "БНХАУ-д хэрхэн суралцах тухай мэдээлэл, Тэтгэлэг авах, материал бүрдүүлэх, CSCA-ын шалгалтын тухай үнэ төлбөргүй зөвлөмж зөвлөгөө",
    "Төгсөх ангийн сурагчдад зориулсан 5+5 буюу хагас жил Монголд, хагас жил Хятадад суралцуулах Хятад хэлний тэтгэлэгт хөтөлбөр",
    "БНХАУ-д суралцах хүсэлтэй ахлах ангийн сурагчдыг тэтгэлгийн шаардлага болох HSK, HSKK, IELTC оноонд урьдчилан бэлдэх, мэдээллээр тогтмол хангах зорилго бүхий Хятад, Англи хос хэлний хагас жил, бүтэн жилийн хосолсон хөтөлбөр",
    "БНХАУ-д хагас жил Хятад хэлний бэлтгэл хагас жил CSCA-ын шалгалтад бэлдэх хосолсон хөтөлбөр зэрэг сургалт хөтөлбөрүүдийг Монголд анх удаа хэрэгжүүлж амжилттай ажиллаж байна."
  ],
  closing: "Бид мөн \"Тэг-ээс ТЭТГЭЛЭГТ ТЭНЦЭХ хүртэл нь...\" гэсэн уриа, нийгмийн хариуцлагынхаа хүрээнд MBG-ын нэрэмжит тэтгэлэгт төсөл хөтөлбөрийг хэрэгжүүлж, манай төсөлд хамрагдсан хүүхэд залуус маань тэтгэлэгт амжилттай хамрагдан бид хамтдаа өөрийн салбараа түүчээлэн түүх бүтээсээр байна."
}

export const valueProposition = {
  title: "Хятадын хэлийг эзэмшиж, ирээдүйгээ бүтээнэ үү",
  subtitle: "Дэлхийн хамгийн том эдийн засгийн гүрний хэлийг эзэмшиж, ирээдүйн боломжуудыг нээж аваарай",
  benefits: [
    {
      title: "Мэргэжлийн багш нар",
      description: "Хятадаас боловсрол эзэмшсэн мэргэжлийн багш нар",
      icon: "👨‍🏫"
    },
    {
      title: "Олон улсын сертификат",
      description: "HSK болон олон улсын хүлээн зөвшөөрөгдсөн сертификат",
      icon: "🏆"
    },
    {
      title: "Уян хатан цаг",
      description: "Таны цаг хуваарьт тохирсон уян хатан сургалтын цаг",
      icon: "⏰"
    },
    {
      title: "Бодит дадлага",
      description: "Бодит нөхцөл байдалд хэрэглэх боломжтой дадлага",
      icon: "🗣️"
    }
  ]
}

export const features = [
  {
    title: "HSK бэлтгэл",
    description: "HSK-ийн бүх түвшинд мэргэжлийн бэлтгэл",
    icon: "📚"
  },
  {
    title: "Бизнес хятад хэл",
    description: "Ажлын орчинд шаардлагатай хятад хэлний мэдлэг",
    icon: "💼"
  },
  {
    title: "Хэлээр харилцах",
    description: "Өдөр тутмын амьдралд хэрэглэх харилцааны хэл",
    icon: "🗣️"
  },
  {
    title: "Онлайн сургалт",
    description: "Гэрээсээ суралцах онлайн хичээлүүд",
    icon: "💻"
  }
]

export const testimonials = [
  {
    name: "Батбаяр",
    role: "Оюутан",
    content: "MBG-ийн тусламжтайгаар HSK 6 түвшинд хүрч, Бээжингийн их сургуульд тэтгэлэгтэй суралцаж байна.",
    rating: 5,
    image: "https://placekeanu.com/100/100"
  },
  {
    name: "Сарангэрэл",
    role: "Ажилтан",
    content: "Хятад хэлийг эзэмшсэний дараа олон улсын компанид ажлын боломж олдлоо.",
    rating: 5,
    image: "https://placekeanu.com/100/100"
  },
  {
    name: "Мөнхбат",
    role: "Бизнесмен",
    content: "Хятадтай худалдаа хийхэд хэлний мэдлэг маш их тустай болж байна.",
    rating: 5,
    image: "https://placekeanu.com/100/100"
  }
]

export const partners = [
  {
    name: "Пекинг",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Peking_University_seal.svg/1024px-Peking_University_seal.svg.png",
    url: "https://www.pku.edu.cn/"
  },
  {
    name: "Цинхуа",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Tsinghua_University_Logo.svg/2560px-Tsinghua_University_Logo.svg.png",
    url: "https://www.tsinghua.edu.cn/"
  },

  {
    name: "Фудан",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Fudan_University_Logo.svg/2565px-Fudan_University_Logo.svg.png",
    url: "https://www.fudan.edu.cn/"
  },
  {
    name: "Шанхайын ЖИАО Тонг",
    logo: "https://upload.wikimedia.org/wikipedia/en/d/da/Sjtu-logo-standard-red.png",
    url: "https://www.sjtu.edu.cn/"
  },
  {
    name: "Харвард",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Harvard_University_coat_of_arms.svg/2560px-Harvard_University_coat_of_arms.svg.png",
    url: "https://www.harvard.edu/"
  },
  {
    name: "Стэнфорд",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Seal_of_Leland_Stanford_Junior_University.svg/2560px-Seal_of_Leland_Stanford_Junior_University.svg.png",
    url: "https://www.stanford.edu/"
  },
  {
    name: "MIT",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/4/44/MIT_Seal.svg/2568px-MIT_Seal.svg.png",
    url: "https://www.mit.edu/"
  }
]

export const faq = [
  {
    question: "Сургалтын хугацаа хэр үргэлжлэх вэ?",
    answer: "Сургалтын хугацаа таны сонгосон хөтөлбөрөөс хамаарч 40 цагаас 1 жил хүртэл байна."
  },
  {
    question: "Онлайн сургалт байдаг уу?",
    answer: "Тийм, бид онлайн болон танхимын сургалт хоёуланг нь санал болгодог."
  },
  {
    question: "HSK шалгалтанд бэлтгэх үү?",
    answer: "Тийм, HSK-ийн бүх түвшинд мэргэжлийн бэлтгэл хийдэг."
  },
  {
    question: "Тэтгэлэгт хөтөлбөрт оролцох боломжтой юу?",
    answer: "Тийм, бид Хятадын их сургуулиудын тэтгэлэгт хөтөлбөрүүдэд оролцоход тусалдаг."
  }
]



export const siteConfig = {
  name: "MBG Education Center",
  description: "Гадаад хэл, Тэтгэлэгт хөтөлбөр, Практик сургалт ...",
  tagline: "Тэг-ээс ТЭТГЭЛЭГТ ТЭНЦЭХ хүртэл нь...",
  slogan: "MBG Боловсролын Төв 10 дахь жилдээ",
  url: "https://mbg.mn",
  ogImage: "https://raw.githubusercontent.com/enkhbold470/mbg-landing/refs/heads/main/public/og.jpg",
  
  // Холбоо барих мэдээлэл
  contact: {
    email: ["info@mbg.mn", "training@mbg.mn", " admission@mbg.mn"],
    phones: [
      "(+976) 77117678",
      "(+976) 99797678", 
      "(+976) 88299289"


    ],
    address: {
      mongolian: "Улаанбаатар, Сүхбаатар дүүрэг, 8-р хороо, Танан төв 202",
      english: "Room 202, Tanan Center, Student Street, 8th Khoroo, Sukhbaatar District, Ulaanbaatar, Mongolia"
    },
    social: {
      facebook: [
        {
          name: "Learning China",
          url: "https://www.facebook.com/learningchina"
        },
        {
          name: "MBG Education Center", 
          url: "https://www.facebook.com/MBGeduMBGtourMBGConsulting"
        }
      ],
      instagram: [
        {
          name: "MBG Education Center",
          url: "https://www.instagram.com/mbg_edu_center"
        }
      ],
      whatsapp: [
        {
          name: "WhatsApp",
          url: "https://wa.me/97699797678"
        }
      ]
    }
  },

  // Нийгмийн холбоосууд
  links: {
    // twitter: "https://twitter.com/mbgeducation",
    github: "mailto:info@mbg.mn",
    facebook: "https://www.facebook.com/learningchina",
    instagramChat: "https://ig.me/j/AbbT2vyfIuOviU7f",
    /** Тэтгэлэг / бүртгэлийн систем */
    apply: "https://apply.mbg.mn",
    /** MBG дэлгүүр — ном, сургалтын материал */
    shop: "https://shop.mbg.mn",
    /** Орчуулгын үйлчилгээ */
    orchuulga: "https://orchuulga.mbg.mn",
  },
} as const

export type SiteConfig = typeof siteConfig

export const metaConfig = {
  generator: 'Next.js',
  title: 'MBG Боловсролын Төв',
  description: 'MBG Боловсролын Төв - Хятад, Англи хэлний мэргэжлийн сургалт, HSK бэлтгэл, тэтгэлэгт хөтөлбөр. Тэг-ээс ТЭТГЭЛЭГТ ТЭНЦЭХ хүртэл. 10 дахь жилдээ.',
  url: 'https://mbg.mn',
  ogImage: 'https://raw.githubusercontent.com/enkhbold470/mbg-landing/refs/heads/main/public/og.jpg',
  keywords: [
    'MBG Боловсрол', 'Хятад хэл', 'HSK', 'Хятадын боловсрол',
    'Хэл сургалт', 'Монгол', 'Хятадын хэлний сургалт', 'Улаанбаатар'
  ],
  applicationName: 'MBG Боловсрол',
  referrer: 'origin-when-cross-origin',
  
  authors: [{ name: 'Энхболд Ганболд', url: 'https://github.com/enkhbold470' }],
  creator: 'MBG Education Center',
  publisher: 'MBG Education Center',
};


export const ctaSection = {
  title: `${siteConfig.tagline}`,
  subtitle: "Хятад хэлийг эзэмшиж, ирээдүйн боломжуудыг нээж аваарай",
  primaryCta: {
    text: "Үнэгүй зөвлөгөө авах",
    href: "/#contact"
  },
  secondaryCta: { 
    text: "Сургалтын хөтөлбөрүүд",
    href: "/courses"
  },
  thirdCta: {
    text: "Бусад үйлчилгээ",
    href: "mailto:info@mbg.mn"
  }

}
